export default "__VITE_PUBLIC_ASSET__10716f79__"